import { createAction } from 'redux-act'

import { MemberInfo } from '../types'

export const setMemberInfo = createAction<MemberInfo>('set member info')

export const setPaymentsLoadStatus = createAction<any>('set payments load status')

export const setPaymentsAuthStatus = createAction<any>('set payments auth status')
export const setPaymentsAuthStart = createAction('set payments auth start')

export const setPaymentsInitStart = createAction('set payments init start')
export const setPaymentsInitSuccess = createAction('set payments init success')
export const setPaymentsInitFail = createAction('set payments init fail')

export const fetchStoreActivationSessionStart = createAction('fetch store activation session start')
export const fetchStoreActivationSessionSuccess = createAction<any>(
  'fetch store activation session success',
)
export const storeActivationFail = createAction<any>('store activation fail')

export const fetchStoreActivationInfoStart = createAction('fetch store activation info start')
export const fetchStoreActivationInfoSuccess = createAction<any>(
  'fetch store activation info success',
)
export const fetchStoreActivationInfoFail = createAction<any>('fetch store activation info fail')
